/**
 * Type of rejection reason for a THG quote rejected by the UBA.
 * Mirrors backend enum ThgRejectionTypeEnum.
 */
export enum ThgRejectionTypeEnum {
  DUPLICATE_REGISTRATION = "duplicate_registration",
  OUTDATED_REGISTRATION_DOCUMENT = "outdated_registration_document",
  MISSING_REGISTRATION_PROOF = "missing_registration_proof",
  NO_ESTIMATION_VALUE = "no_estimation_value",
  OTHER = "other"
}
